// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"4d6a2aba","234":"bf4e7b51","716":"a62dff18"}[chunkId] + ".chunk.js";
};